import { styled } from '@mui/material';

import { DESKTOP_MIN_WIDTH } from '~/constants/common';
import { COLORS } from '~/styles/colors';

export const StyledLogosContainer = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    gap: '16px',
    flexWrap: 'wrap',
    [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
      flexWrap: 'nowrap',
      overflow: 'auto',
      overscrollBehavior: 'contain',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  };
});

interface StyledLogoButtonProps {
  $isSelected?: boolean;
}

export const StyledLogoButton = styled('button')<StyledLogoButtonProps>(({ $isSelected }) => {
  return {
    borderRadius: '10px',
    backgroundColor: $isSelected ? COLORS.blue50 : COLORS.lightGray,
    border: `1px solid ${$isSelected ? COLORS.blue100 : COLORS.lightGray}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '70px',
    minWidth: '70px',
    height: '70px',
    cursor: 'pointer',
  };
});
